import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { gdCustomerFeaturesLeft, gdCustomerFeaturesRight } from "../gdModulesData";
import GdImagePlaceholder from "./GdImagePlaceholder";

const FeatureList: React.FC<{ items: string[]; align: "left" | "right" }> = ({ items, align }) => (
  <ul className={`gd-customer__list gd-customer__list--${align}`}>
    {items.map((item, index) => (
      <motion.li
        key={item}
        initial={{ opacity: 0, x: align === "left" ? -12 : 12 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.4, delay: index * 0.04 }}
      >
        <span className="gd-customer__dot" aria-hidden="true" />
        {item}
      </motion.li>
    ))}
  </ul>
);

const GdCustomerAppSection: React.FC = () => {
  return (
    <section className="gd-customer" aria-labelledby="gd-customer-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2
            id="gd-customer-title"
            className="wdev-section-head__title wdev-section-head__title--dark wdev-section-head__title--underline"
          >
            Grocery Delivery Customer App
          </h2>
          <p className="gd-customer__lead">
            A highly-interactive Grocery app for Customer with user-friendly UI/UX.
          </p>
        </AnimatedSection>

        <div className="gd-customer__layout">
          <FeatureList items={gdCustomerFeaturesLeft} align="left" />

          <AnimatedSection className="gd-customer__center" delay={0.1}>
            <GdImagePlaceholder
              variant="phone"
              label="Customer App"
              hint="Product listing · Search · Cart · Checkout"
              className="gd-customer__placeholder"
            />
          </AnimatedSection>

          <FeatureList items={gdCustomerFeaturesRight} align="right" />
        </div>
      </div>
    </section>
  );
};

export default GdCustomerAppSection;
